// extracted by mini-css-extract-plugin
export var carrierTab = "_5e-0";
export var carrierTabActive = "_5e-1 _5e-0";
export var carrierTabInactive = "_5e-2 _5e-0";
export var carrierTabLabel = "_5e-3";
export var carrierTabLabelActive = "_5e-4 _5e-3";
export var carrierTabLabelInactive = "_5e-5 _5e-3";
export var carrierTabPercentage = "_5e-6";
export var carrierTabPercentageActive = "_5e-7 _5e-6";
export var carrierTabPercentageInactive = "_5e-8 _5e-6";
export var carrierTabWinnable = "_5e-9";
export var carrierTabWinnableActive = "_5e-a _5e-9";
export var carrierTabWinnableInactive = "_5e-b _5e-9";
export var comparisonContainer = "_5e-d";
export var missingRateButton = "_5e-n";
export var missingRateButtonActive = "_5e-o _5e-n";
export var missingRateButtonInactive = "_5e-p _5e-n";
export var missingRateButtonLabel = "_5e-q";
export var missingRateButtonLabelActive = "_5e-r _5e-q";
export var missingRateButtonLabelInactive = "_5e-s _5e-q";
export var sidebar = "_5e-c";
export var strategyButton = "_5e-e";
export var strategyButtonActive = "_5e-f _5e-e";
export var strategyButtonDescription = "_5e-k";
export var strategyButtonDescriptionActive = "_5e-l _5e-k";
export var strategyButtonDescriptionInactive = "_5e-m _5e-k";
export var strategyButtonInactive = "_5e-g _5e-e";
export var strategyButtonLabel = "_5e-h";
export var strategyButtonLabelActive = "_5e-i _5e-h";
export var strategyButtonLabelInactive = "_5e-j _5e-h";
export var unitToggleButton = "_5e-t";
export var unitToggleButtonActive = "_5e-u _5e-t";
export var unitToggleButtonInactive = "_5e-v _5e-t";
export var unitToggleButtonLabel = "_5e-w";
export var unitToggleButtonLabelActive = "_5e-x _5e-w";
export var unitToggleButtonLabelInactive = "_5e-y _5e-w";